import { GridFilterItem } from '@mui/x-data-grid-pro';
import { ArchivePoint } from '@src/types/Archivist';
import { PaginationModel } from '@src/types/pagination/PaginationModel';

export enum DeviceTypeCategory {
  RACK = 'rack',
}

export enum FilterField {
  DEVICE_TYPE = 'deviceType',
  PARENT_DEVICE_ID = 'parentDeviceId',
  DEVICE_ID = 'deviceId',
  POINT_NAME = 'pointName',
}

export const FILTER_FIELDS = Object.values(FilterField);

export interface FilterState {
  deviceType: string;
  parentDeviceId: string;
  deviceId: string;
  pointName: string;
}

export interface FilterOptions {
  deviceType: string[];
  parentDeviceId: string[];
  deviceId: string[];
  pointName: string[];
}

export interface FilterLoadingState {
  deviceType: boolean;
  parentDeviceId: boolean;
  deviceId: boolean;
  pointName: boolean;
}

export interface DataPointSearchState {
  filters: FilterState;
  gridFilters: GridFilterItem[];
  searchText: string;
  activeSearch: string;
  pagination: PaginationModel;
  selection: Map<string, ArchivePoint>;
  isModalOpen: boolean;
}

export enum DataPointSearchActionType {
  SET_FILTER = 'SET_FILTER',
  SET_GRID_FILTERS = 'SET_GRID_FILTERS',
  CLEAR_FILTERS = 'CLEAR_FILTERS',
  SET_SEARCH_TEXT = 'SET_SEARCH_TEXT',
  SUBMIT_SEARCH = 'SUBMIT_SEARCH',
  CLEAR_SEARCH = 'CLEAR_SEARCH',
  SET_PAGINATION = 'SET_PAGINATION',
  RESET_PAGINATION = 'RESET_PAGINATION',
  ADD_TO_SELECTION = 'ADD_TO_SELECTION',
  REMOVE_FROM_SELECTION = 'REMOVE_FROM_SELECTION',
  CLEAR_SELECTION = 'CLEAR_SELECTION',
  SYNC_PAGE_SELECTION = 'SYNC_PAGE_SELECTION',
  RESET_STATE = 'RESET_STATE',
}

export type DataPointSearchAction =
  | {
      type: DataPointSearchActionType.SET_FILTER;
      payload: { field: FilterField; value: string };
    }
  | {
      type: DataPointSearchActionType.SET_GRID_FILTERS;
      payload: GridFilterItem[];
    }
  | { type: DataPointSearchActionType.CLEAR_FILTERS }
  | { type: DataPointSearchActionType.SET_SEARCH_TEXT; payload: string }
  | { type: DataPointSearchActionType.SUBMIT_SEARCH }
  | { type: DataPointSearchActionType.CLEAR_SEARCH }
  | {
      type: DataPointSearchActionType.SET_PAGINATION;
      payload: Partial<PaginationModel>;
    }
  | { type: DataPointSearchActionType.RESET_PAGINATION }
  | {
      type: DataPointSearchActionType.ADD_TO_SELECTION;
      payload: ArchivePoint[];
    }
  | { type: DataPointSearchActionType.REMOVE_FROM_SELECTION; payload: string[] }
  | { type: DataPointSearchActionType.CLEAR_SELECTION }
  | {
      type: DataPointSearchActionType.SYNC_PAGE_SELECTION;
      payload: { currentPageRows: ArchivePoint[]; selectedIds: string[] };
    }
  | { type: DataPointSearchActionType.RESET_STATE };

export interface SelectedDataPoint {
  topic: string;
  displayName: string;
  pointName: string;
  deviceType: string;
  siteId: string;
  deviceId: string;
  parentDeviceId: string;
  parentDeviceType: string;
  dataType: string;
}

export interface DataPointSearchModalProps {
  open: boolean;
  onClose: () => void;
  onAddDataPoints: (dataPoints: SelectedDataPoint[]) => void;
}
